import useClickOutside from 'hooks/useClickOutside'
import { useRef, useState } from 'react'
import './index.scss'

interface PostProps {
  name: string
  date: string
  desc: string
  addons?: string
  bookIsPublish?: boolean
  shouldBePublished?: boolean
  setModal?: (s: string) => void
  setBookId?: () => void
}

const Post: React.FC<PostProps> = ({ name, date, desc, addons, bookIsPublish, shouldBePublished, setModal, setBookId }) => {
  const [isFullText, setIsFullText] = useState<boolean>(false)
  const [isDropdownVisible, setDropdownVisible] = useState<boolean>(false)

  const wrapperRef = useRef<HTMLDivElement>(null)

  useClickOutside(wrapperRef, () => {
    setDropdownVisible(false)
  })

  const truncateText = (text: string, wordCount: number): string => {
    const words = text.trim().split(/\s+/)
    if (words.length > wordCount) {
      return words.slice(0, wordCount).join(' ') + ' ...'
    } else {
      return text
    }
  }

  const displayText = isFullText ? desc : truncateText(desc, 19)

  return (
    <div className="post">
      <div className="post__head">
        <div>
          <h2>{name}</h2>
          <span>{date}</span>
          <span>{addons ? ', ' + addons : undefined}</span>
        </div>
        <div>
          {addons && <div className='dots' ref={wrapperRef}>
            <i className="icon icon--dots" onClick={() => setDropdownVisible(!isDropdownVisible)}></i>
            {isDropdownVisible && <div className="dots__dropdown">
              {shouldBePublished && <span onClick={() => {
                setBookId && setBookId()
                setModal && setModal(bookIsPublish ? 'bookPublish' : 'bookUnpublish')
              }}>{bookIsPublish ? 'Ukryj' : 'Opublikuj'}</span>}
              <span onClick={() => {
                setBookId && setBookId()
                setModal && setModal('bookDelete')
              }
              }>Usuń</span>
            </div>}
          </div>}
        </div>
      </div>
      <div className="post__body" onClick={() => isFullText ? setIsFullText(false) : setIsFullText(true)}>
        <p>{displayText}</p>
      </div>
    </div>
  )
}

export default Post